var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXtwitter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.56 149.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcfcfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.75.42C40.39,3.17,16.85,20.52,6.14,45.07A74.82,74.82,0,0,0,45,143.47,74.81,74.81,0,0,0,147.3,93.07c10.14-40.2-14.75-81.31-55.05-90.9A73.34,73.34,0,0,0,66.75.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.33,53c5,6.62,9.19,12.07,9.35,12.07S84,59.62,90.13,53L101.3,40.93h6.35l-1.36,1.44c-.78.81-5.84,6.31-11.26,12.19S84.32,66.16,83.27,67.21l-1.87,2L96,88.63c8,10.71,14.6,19.59,14.6,19.74s-4.79.31-10.59.31l-10.63,0L79.5,95.41c-6.82-9.16-10-13.09-10.32-12.85S63.41,88.71,56.87,95.8L45,108.68H42a11.46,11.46,0,0,1-3-.19c0-.12,6.19-6.89,13.74-15S66.45,78.51,66.53,78.39s-6.15-8.61-13.75-18.77S39,41.12,39,41s4.79-.11,10.67-.11H60.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,46.14c.16.28,10,13.44,21.73,29.17L91.65,104l4.79,0c3,0,4.75-.15,4.67-.39S91.3,90.27,79.46,74.42L57.88,45.6H53.06c-4,0-4.83.08-4.56.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXtwitter2);
export default __webpack_public_path__ + "static/media/icon-xtwitter2.dfb7013179a0d14ddf7799a57334d061.svg";
export { ForwardRef as ReactComponent };